import React, { useContext, useEffect, useState } from 'react';
import EditableField from '../../components/shared/editable-input';
import { RxCross2 } from "react-icons/rx";
import ModalHeading from '../../components/shared/modal-heading';
import { AccountsContext } from '../../components/context/account-context';
import { updateUser } from '../../services/users-service';
import Loader from '../../components/shared/loader';
import { prependDefault } from '../../utils/structure-options-utils';

const EditModal = ({ selectedRow, setSelectedRow, roles, loadingGlobalData, setIsEditModalOpen, fromAdding = false, fetchUsers }) => {
    const { accountId } = useContext(AccountsContext);
    const [copied, setCopied] = useState(false);
    const [loadingFields, setLoadingFields] = useState({});
    const [updateStatus, setUpdateStatus] = useState({ message: '', type: '' });
    const tempPassword = selectedRow ? selectedRow?.password : '';


    // Clear status messages after 2 seconds
    useEffect(() => {
        let timer;
        if (updateStatus.message && updateStatus.type !== 'info') {
            timer = setTimeout(() => {
                setUpdateStatus({ message: '', type: '' });
            }, 2000);
        }
        return () => clearTimeout(timer);
    }, [updateStatus]);

    const handleCopyPassword = async () => {
        try {
            await navigator.clipboard.writeText(tempPassword);
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        } catch (err) {
            console.error('Failed to copy!', err);
            setUpdateStatus({
                message: 'Failed to copy password',
                type: 'error'
            });
        }
    };

    const handleFieldUpdate = async (value, fieldName) => {
        console.log(value, fieldName)
        setLoadingFields(prev => ({ ...prev, [fieldName]: true }));
        setUpdateStatus({ message: '', type: '' });

        const fieldMap = {
            firstName: 'firstName',
            lastName: 'lastName',
            email: 'email',
            msisdn: 'msisdn',
            role: 'role',
            status: 'status'
        };

        const payload = { [fieldMap[fieldName]]: value };

        try {
            const response = await updateUser(accountId, selectedRow.userId, payload);
            console.log(response)
            if (response.success) {
                const updatedRow = { ...selectedRow, [fieldName]: value };
                setSelectedRow(updatedRow);
                fetchUsers();
                setUpdateStatus({
                    message: `${labelMap[fieldName] || fieldName} updated successfully!`,
                    type: 'success'
                });
            } else {
                setUpdateStatus({
                    message: response.data.message || `Failed to update ${labelMap[fieldName] || fieldName}`,
                    type: 'error'
                });
                // throw new Error('API update failed');
            }
        } catch (error) {
            setUpdateStatus({
                message: error.message || `Failed to update ${labelMap[fieldName] || fieldName}`,
                type: 'error'
            });
            throw error;
        } finally {
            setLoadingFields(prev => ({ ...prev, [fieldName]: false }));
        }
    };

    const labelMap = {
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        msisdn: 'Mobile Number',
        role: 'Role',
        status: 'Status'
    };

    const roleOptions = prependDefault(roles.map(v => ({ value: v.slug, label: v.label })), 'Role');

    return (
        <div className="space-y-3 px-4 pt-3 pb-7 relative">
            <ModalHeading className="text-left mb-3">User Detail Information</ModalHeading>

            <button
                className='hover:scale-105 absolute -top-3 -right-2 bg-white border p-2 rounded-full'
                onClick={() => setIsEditModalOpen(false)}>
                <RxCross2 className='text-xl' />
            </button>

            {updateStatus.message && (
                <div className={`px-4 py-2 text-sm ${updateStatus.type === 'success' ? 'text-green-600 bg-green-100' :
                    updateStatus.type === 'error' ? 'text-red-600 bg-red-100' :
                        'text-blue-600 bg-blue-100'} rounded-md mx-4`}>
                    {updateStatus.message}
                </div>
            )}

            {
                loadingGlobalData ? <Loader />
                    :
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                        <EditableField
                            label="First Name"
                            name="firstName"
                            value={selectedRow.firstName || ''}
                            onChange={handleFieldUpdate}
                            type="text"
                            isLoading={loadingFields.firstName}
                        />
                        <EditableField
                            label="Last Name"
                            name="lastName"
                            value={selectedRow.lastName || ''}
                            onChange={handleFieldUpdate}
                            type="text"
                            isLoading={loadingFields.lastName}
                        />
                        <EditableField
                            label="Email"
                            name="email"
                            type="email"
                            value={selectedRow.email || ''}
                            onChange={handleFieldUpdate}
                            isLoading={loadingFields.email}
                        />
                        <EditableField
                            label="Mobile Number"
                            name="msisdn"
                            value={selectedRow.msisdn || ''}
                            onChange={handleFieldUpdate}
                            type="number"
                            isLoading={loadingFields.msisdn}
                        />
                        <EditableField
                            label="Role"
                            name="role"
                            value={selectedRow.role || ''}
                            options={roleOptions}
                            onChange={handleFieldUpdate}
                            type="select"
                            isLoading={loadingFields.role}
                        />
                        <EditableField
                            label="Status"
                            name="status"
                            value={selectedRow.status || 'Submitted'}
                            onChange={handleFieldUpdate}
                            type="select"
                            isEditable={false}
                            isLoading={loadingFields.status}
                        />
                        {fromAdding && (
                            <div className='col-span-2 mt-5'>
                                <p className='text-center text-sm'>Please copy and share this password with the user. It will not be shown again.</p>
                                <div
                                    className='bg-gray-200 mt-2 py-2 px-6 w-full rounded-lg cursor-pointer'
                                    onClick={handleCopyPassword}
                                >
                                    <p className='text-xl text-center text-black'>{tempPassword}</p>
                                </div>
                                {copied && <p className='text-center text-green-700 text-sm mt-1'>Copied!</p>}
                            </div>
                        )}
                    </div>
            }


        </div>
    );
};

export default EditModal;